<template lang="pug">
  div.body.body-table.garbage-table
    div.table-choose-panel
      div.toolbar-table
        e-select-list(
          :options="selectListOptions"
          v-model="operationType"
        )

        div.toolbar.toolbar--modal
          div.line
            form(@submit.prevent="letSearch")
              // input(type="search" placeholder="" v-model="searchModel")
            div.parameters
              e-year-selector(year="year" v-if="operationType != 'product'")
            div(
              v-if="!editDisabled"
            ).actions-panel
              e-button-add(@click.prevent.stop="addNewRowToGarbageTable")
              // button(type="button" @click="addNewRowToGarbageTable").actions-panel__button.btn-add.green

      div(v-if="operationType == 'detail'")
        e-table-editable(
          ref="detail"
          :attributes="garbageDetailAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
          :enabledActions="enabledActions"
        )

      div(v-if="operationType == 'input'")
        e-table-editable(
          ref="input"
          :attributes="garbageInputAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
          :enabledActions="enabledActions"
        )

      div(v-if="operationType == 'output'")
        e-table-editable(
          ref="output"
          :attributes="garbageOutputAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :enableOnAdd="enableOnAdd"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
          :enabledActions="enabledActions"
        )

      div(v-if="operationType == 'product'")
        e-table-editable(
          ref="inputProduct"
          :attributes="garbageInputProductAttr"
          :dataUrl="garbageDataUrl"
          :postUrl="garbagePostUrl"
          :patchUrl="garbagePatchUrl"
          :deleteUrl="garbageDeleteUrl"
          :tableInOnlineMode="tableInOnlineMode"
          :afterFetchData="afterFetchData"
          :afterValidate="afterValidate"
          :enabledActions="enabledActions"
        )
</template>

<script>
  import registryObjectGarbageTableMixin from '../components/mixins/registry-object-garbage-table-mixin'

  export default {
    name: 'r-registry-object-garbage-table',
    mixins: [registryObjectGarbageTableMixin],
    computed: {
      selectListOptions () {
        let menuItems = [
          {
            id: 'detail',
            name: 'Движение отходов'
          },
          {
            id: 'input',
            name: 'Сведения о полученных отходах'
          },
          {
            id: 'output',
            name: 'Сведения о переданных отходах'
          }
        ]
        if (this.showInputProduct) {
          menuItems.push({
            id: 'product',
            name: 'Полученная продукция'
          })
        }
        return menuItems
      },
      enableOnAdd () {
        return ['fkkoName', 'code', 'total', 'total_cubic', 'count', 'count_cubic', 'tkoObjectName', 'entityName', 'amount']
      },
      garbageInputAttr () {
        return {
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          entityName: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название организации',
            label: 'Организация, которая передала отходы',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelectEntity,
              suggestionEndpoint: this.suggestionEntityEndpoint,
              transformSuggestions: this.transformEntitySuggestions
            }
          },
          total: {
            label: 'Количество отходов, тонн',
            required: true
          },
          total_cubic: {
            label: 'Количество отходов, м<sup>3</sup>',
            required: true
          }
        }
      },
      garbageOutputAttr () {
        return {
          fkkoName: {
            label: 'Наименование',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions
            }
          },
          code: {
            label: 'Код ФККО',
            required: true,
            placeholder: ' ',
            disabled: true,
            validationRulePattern: '^((\\d*\\s*)*)$'
          },
          tkoObjectName: {
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить название объекта',
            label: 'Объект обращения, которому переданы отходы',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelectTKO,
              suggestionEndpoint: this.suggestionTKOEndpoint,
              transformSuggestions: this.transformTKOSuggestions
            }
          },
          total: {
            label: 'Количество отходов, тонн',
            required: true
          },
          total_cubic: {
            label: 'Количество отходов, м<sup>3</sup>'
          }
        }
      }
    }
  }
</script>
